/**
 * Gullak Cash 登录相关 hook
 * 封装登录状态和登录弹窗逻辑
 */

import { useAtomValue } from 'jotai';
import { isLoginAtom } from '@/store';
import { showLoginModal } from '@/features/auth/components/login-form';
import { useCallback } from 'react';
import { useLoginResult } from '@/features/auth/hooks/use-login-result';

export interface UseGullakLoginResult {
  /** 是否已登录 */
  isLogin: boolean;
  /** 显示登录弹窗 */
  handleShowLoginModal: () => Promise<any>;
  /** 检查登录状态，未登录时显示登录弹窗，已登录时执行回调 */
  checkLoginAndExecute: (callback: () => void | Promise<void>) => Promise<void>;
}

/**
 * Gullak Cash 登录相关 hook
 * @returns 登录状态和登录弹窗方法
 */
export function useGullakLogin(): UseGullakLoginResult {
  const isLogin = useAtomValue(isLoginAtom);
  const { loginSuccess } = useLoginResult();

  // 显示登录弹窗
  const handleShowLoginModal = useCallback(async () => {
    const token = await showLoginModal({ source: 'Gullak' });
    if (token) {
      loginSuccess(token as string);
    }
    return token;
  }, []);
  
  // 检查登录状态，未登录时显示登录弹窗
  const checkLoginAndExecute = useCallback(
    async (callback: () => void | Promise<void>) => {
      if (!isLogin) {   
        await handleShowLoginModal();
        return;
      }
      await callback();
    },
    [isLogin, handleShowLoginModal]
  );

  return {
    isLogin,
    handleShowLoginModal,
    checkLoginAndExecute,
  };
}
